module.exports = __webpack_public_path__ + "img/collection-weddingRingsTensionRings.65030ec.webp";